import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openObjectTypeDetails: {
		id: 'assets-object-graph.object-type-view.open-object-type-details',
		defaultMessage: 'Open object type details page',
		description:
			'Tooltip message instructing the user to click the link to open the "object details" page',
	},
	maxOfTypeExceeded: {
		id: 'assets-object-graph.object-type-view.max-of-type-exceeded',
		defaultMessage:
			'The number of objects of this type were too many to be represented individually in the graph and have therefore been grouped together in a single node.',
		description:
			'Message explaining that there are too many nodes of the same type being shown. As a result, they have been merged into a single node and displayed as their over-arching type',
	},
});
